module.exports = __webpack_public_path__ + "d01c80bd398c230d7f8b4d85a405983f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/neu/einpersonenhaushalt-neu.svg
// module id = 135
// module chunks = 1